import { AudioManager, ITrack, Track } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { LogGroup, Size, Scale, SetStyles, Log } from "../../MyHelpers";
import { MyVideo } from "../../MyVideo";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource, VideoResource2 } from "../../ResourceManager/VideoResource";
import { Settings, JackpotDisplayType } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { SpinAndHoldParams } from "../Bonus/SpinAndHold/SpinAndHoldParams";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ITransition } from "./ITransition";
import { TweenMax } from "gsap";
import { ITransitionParams } from "./ITransitionFactory";
import { ITimeout } from "../../Context/Timeout";

export class VideoNoSpriteTransition implements ITransition {

    protected systemContext: ISystemContext = null;
    protected params: ITransitionParams = null;

    protected view: HTMLElement = null;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected logGroup: LogGroup = null;
    protected gameName: string = null;
    protected TitleSpriteTransition: CanvasSprite = null;
    protected spriteResource : SpriteResource ;
    protected videoResource : VideoResource2;
    protected track : ITrack ; 
    protected nameResource : string;
    protected fadeOut : boolean;

    public onTransitionStart: () => void = null;
    public onTransitionEnd:   () => void = null;
    

    protected audioDelay: ITimeout;

    protected video: MyVideo;

    public constructor( params: ITransitionParams) 
    {
        this.params = params;
        this.resid = params.resid;
        this.audio = params.audio;
        this.logGroup = params.logGroup
        this.gameName = params.gameName;
        this.systemContext = params.systemContext.CreateSubContext("VideoNoSprite");
        this.spriteResource = params.spriteResource;
        this.track = params.soundResource;
        this.videoResource = params.videoResource;
        this.nameResource = params.nameResource;
        this.fadeOut = params.fadeOut;

        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add(this.gameName + "TransitionSpinHold");

        this.audioDelay = this.systemContext.TimingContext().CreateTimeout("audioDelay", 800, () => {
            this.track.Play();
        });
    }
    
    OnResize(): void {
        throw new Error("Method not implemented.");
    }

    //public CreateTransitionPixi: () => void = null;
    //public DestroyTransitionPixi: () => void = null;
    public CreateTransitionPixi () {};
    public DestroyTransitionPixi () {};


    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> 
    {
    };

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        SetStyles(this.videoResource.video.View(), {
            position: "absolute",
            bottom: Scale.Ypx(0),
            left: Scale.Xpx(0),
            zIndex: ZIndex.BonusTransition.toString() 
        });
        
        this.systemContext.SharedVideoContext().AddVideo(this.videoResource.video);
        this.videoResource.video.AddOnEndedCallback(this.resid, this.TransitionEnded.bind(this));

        // store video reference
        this.video = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(this.nameResource));
    };
    
    protected started: boolean = false;
    public ShowTransiton(): void {
        if (this.started == false)
        {
            this.started = true;
            // Log.Debug(this.logGroup, "Start transition");
            this.video.Play(this.resid);
            TweenMax.set(this.video.View(), { autoAlpha: 1 });
            
            // show video
            this.video.Show();
            
            // play sound

            this.audioDelay.Start();
            this.fadeSettings(this.video)

            this.onTransitionStart?.();
        }
    };

    protected fadeSettings(video : MyVideo) {
        
        if (this.fadeOut == true){

            //FADE OUT VIDEO 
            setTimeout(() =>
            TweenMax.to(video.View(), 2, {
                autoAlpha: 0, onComplete: () => {
                    video.StopAndReset(this.resid);
                    video.Hide();

                }
            }
            ), video.Duration() / 2.5);
        }
        else 
        {
            //nothing to do     
        }        
        
    }    
         
        
    
    public View(): HTMLElement {
        return this.view
     };

    protected TransitionEnded(): void
    {
        this.started = false;

        this.onTransitionEnd?.();
    }

    public Update():void
    {
        //this.TitleSpriteTransition.Update();
    }
}
